import type { Metric } from "@/services/api/types";
import type { RootState } from "@/store/store";
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

type PreloadedData<T> = {
  data: T;
  isLoading: boolean;
};

type CloneContextState = {
  searchMetrics: PreloadedData<Metric[]>;
};

const initialState = {
  searchMetrics: {
    data: [],
    isLoading: false,
  },
} as CloneContextState;

const cloneContextReducer = createSlice({
  name: "cloneContext",
  initialState,
  reducers: {
    setSearchMetrics: (state, action: PayloadAction<PreloadedData<Metric[]>>) => {
      return {
        ...state,
        searchMetrics: action.payload,
      };
    },
  },
});

export const { setSearchMetrics } = cloneContextReducer.actions;

export const getSearchMetrics = (state: RootState): PreloadedData<Metric[]> => state.cloneContext.searchMetrics;
export default cloneContextReducer.reducer;
